import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-admin-office-type-add',
  templateUrl: './admin-office-type-add.component.html'
})
export class AdminOfficeTypeAddComponent implements OnInit {
  @Input() formdata;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  

  constructor(
    private fb: FormBuilder,
    private router: Router) { }

  ngOnInit() {
    this.form = this.fb.group({
      id: [null, ''],
      name: ['', ''],
      abbreviation: ['', ''],
      sort: ['', '']
    });
    
    this.router.events.subscribe(r => {
      if (r instanceof NavigationEnd) {
        this.form.reset();
      }
    });
  }

  saveOfficeType() {
    this.doSave.emit(this.form.value);
    this.form.reset();
  }

  cancel() {
    this.doCancel.emit();
  }
}
